<template>
  <div class="compare-wrap">
    <div class="info-data-wrap" style="overflow: hidden;">
      <div style="display:flex;justify-content: space-between;
      margin-bottom: 10px;flex-wrap:wrap;">
        <div style="width: 180px;">专业类别：{{ userInfo.zylb }}</div>
        <div style="width: 180px;">综合成绩：{{ userInfo.equivalent }}</div>
        <div style="width: 180px;">姓名：{{userInfo.xm}}</div>
        <div style="width: 180px;">性别：{{ userInfo.xb==1?'男':userInfo.xb==2?'女':'' }}</div>
        <div style="width: 180px;">手机号码：{{ userInfo.sjhm }}</div>
        <div style="width: 180px;">政策性加分：{{ userInfo.yfjf }}</div>
      </div>
      <div style="display:flex;justify-content: space-between;
      margin-bottom: 10px;flex-wrap:wrap;">
        <div style="width: 180px;">首选科目：{{ userInfo.sxkm==1?'历史':userInfo.sxkm==2?'物理':'' }} {{ userInfo.sxkmcj }}</div>
        <div style="width: 180px;">再选科目：
                <span v-if="(userInfo.zxkma===1&&userInfo.zxkmb===2)
                ||(userInfo.zxkmb===1&&userInfo.zxkma===2)">政治 {{ userInfo.zxkmacj }}  地理 </span>
                <span v-if="(userInfo.zxkma===1&&userInfo.zxkmb===3)
                ||(userInfo.zxkmb===1&&userInfo.zxkma===3)">化学  {{ userInfo.zxkmacj }} 政治</span>
                <span v-if="(userInfo.zxkma===1&&userInfo.zxkmb===4)
                ||(userInfo.zxkmb===1&&userInfo.zxkma==4)">政治  {{ userInfo.zxkmacj }} 生物</span>
                <span v-if="(userInfo.zxkma===2&&userInfo.zxkmb===3)
                ||(userInfo.zxkmb===2&&userInfo.zxkma==3)">化学  {{ userInfo.zxkmacj }} 地理 </span>
                <span v-if="(userInfo.zxkma===2&&userInfo.zxkmb===4)
                ||(userInfo.zxkmb===2&&userInfo.zxkma==4)">地理  {{ userInfo.zxkmacj }} 生物</span>
                <span v-if="(userInfo.zxkma===3&&userInfo.zxkmb===4)
                ||(userInfo.zxkmb===3&&userInfo.zxkma==4)">化学  {{ userInfo.zxkmacj }} 生物</span>
                {{ userInfo.zxkmbcj }}
        </div>
        <div style="width: 180px;">文化成绩：{{ userInfo.gkfs }}</div>
        <div style="width: 180px;display: flex;">
          <div style="width:90px;">语文：{{ userInfo.ywcj }}</div>
          <div style="width:90px;">数学：{{ userInfo.sxcj }}</div>
        </div>
        <div style="width:180px;">外语：{{ userInfo.wycj }}</div>
        <div style="width: 180px;">专业成绩：{{ userInfo.zscore }}</div>
      </div>
      <!-- <div style="display:flex;justify-content: flex-start;gap:86px;
        margin-bottom: 10px;flex-wrap:wrap;">
        <div style="width:180px;">语文：{{ userInfo.ywcj }}</div>
        <div style="width:180px;">数学：{{ userInfo.sxcj }}</div>
        <div style="width:180px;">外语：{{ userInfo.wycj }}</div>
      </div> -->
      <!-- <div class="sort-wrap">
        <el-button type="success" icon="el-icon-sort" plain size="small" @click="sortData">投档线从低到高排序</el-button>
      </div> -->
      <!-- <table class="info-data">
       <tr>
        <th width="40px">序号</th>
        <th width="70px">院校代号</th>
        <th width="130px" class="merge">院校名称</th>
        <th width="60px">专业组</th>
        <th width="100px">批次</th>
        <th width="100px">专业类别</th>
        <th width="80px">历年平均投档线</th>
      </tr>
    </table> -->
    <!-- <table class="info-data" v-for="(item, index1) in colleges" :key="item.gbdm+item.zyz">
      <tr v-for="(innerItem, index) in item.tdx" :key="index">
        <td width="40px" v-if="index === 0" :rowspan= "item.tdx.length">{{index1+1}}</td>
        <td v-if="index === 0" :rowspan= "item.tdx.length" width="70px" class="merge">{{ item.sb }}</td>
        <el-tooltip  placement="top">
          <div slot="content">{{ item.yxmc }}</div>
          <td v-if="index === 0" :rowspan= "item.tdx.length"
          width="130px" class="merge" style="white-space:nowrap;
          text-overflow:ellipsis;overflow:hidden;">{{ item.yxmc }}</td>
        </el-tooltip>
        <td width="60px">{{ item.zyz?item.zyz:'-' }}</td>
        <td width="100px">{{ innerItem.pc==="0"?"本科提前批":
        innerItem.pc==="9"?"专科提前批":
        innerItem.pc==="7"?"高职专科批":innerItem.pc==="6"?"本科批":innerItem.pc===0?"本科提前批":
        innerItem.pc===9?"专科提前批": innerItem.pc===7?"高职专科批":innerItem.pc===6?"本科批":
        innerItem.pc?innerItem.pc:"-"}}</td>
        <el-tooltip  placement="top">
          <div slot="content">
            {{ innerItem.lb?innerItem.lb:'-' }}
          </div>
          <td width="100px;" style="white-space:nowrap;
          text-overflow:ellipsis;overflow:hidden;">{{ innerItem.lb?innerItem.lb:'-' }}</td>
        </el-tooltip>
        <td width="80px">{{ innerItem.tdx === '0'?'-': innerItem.tdx}}</td>
      </tr>
    </table> -->
      
    <!-- v-for="(innerItem, index) in item.tdx" :key="index" 
     :rowspan= "item.tdx.length" v-if="index === 0" 
     
        <td width="100px">{{ item.pc==="0"?"本科提前批":
        item.pc==="9"?"专科提前批":
        item.pc==="7"?"高职专科批":item.pc==="6"?"本科批":item.pc===0?"本科提前批":
        item.pc===9?"专科提前批": item.pc===7?"高职专科批":item.pc===6?"本科批":
        item.pc?item.pc:"-"}}</td>
        <th width="100px">批次</th>-->
        
      <div class="sort-wrap" style="display:flex;justify-content:space-between;margin-bottom:10px;">
        <el-button type="success" icon="el-icon-sort" plain size="small" @click="sortData2">降序</el-button>
        <el-button type="success" icon="el-icon-sort" plain size="small" @click="sortData3">升序</el-button>
      </div>
        <div style="display:none;">
          <table class="info-data">
            <tr>
              <th width="40px">序号</th>
              <th width="70px">院校代号</th>
              <th width="130px" class="merge"> 院校名称</th>
              <th width="80px">专业组</th>
              <th width="80px">投档线</th>
              <th width="112px">专业一</th>
              <th width="112px">专业二</th>
              <th width="112px">专业三</th>
              <th width="112px">专业四</th>
              <th width="112px">专业五</th>
              <th width="112px">专业六</th>
              <th width="50px">是否服从</th>
            </tr>
          </table>
        </div>
    <div style="overflow-y: auto;height: 300px;display:none;">
      <table class="info-data" style="table-layout: auto;">

        <tr v-for="(item, index1) in colleges" :key="(index1)">
          <td width="40px"
          style="max-width: 57px;">{{index1/3+1}}</td>
          <td width="60px" class="merge">{{ item.sb }}</td>
          <el-tooltip  placement="top">
            <div slot="content">{{ item.yxmc }}</div>
            <td 
            width="130px" class="merge" style="white-space:nowrap;
            text-overflow:ellipsis;overflow:hidden;max-width: 185px;"
            >{{ item.yxmc }}</td>
          </el-tooltip>
          <td width="80px"
          style="max-width: 85px;">{{ item.zyz?item.zyz:'-' }}</td>
          <td width="80px">
            <table class="info-data">
              <template v-if="item.tdxList">
                <tr v-for="(item2,index2) in item.tdxList" :key="index2">
                  <td>{{item2.nd}}</td>
                  <td>{{item2.lowestScore}}</td>
                </tr>
              </template>
            </table>
          </td>
          <el-tooltip  placement="top">
            <div slot="content">
              {{ item.zydhStr1?item.zydhStr1:'-' }}
            </div>
            <td width="112px" style="white-space:nowrap;
            text-overflow:ellipsis;overflow:hidden;max-width: 113px;">
              {{ item.zydhStr1?item.zydhStr1:'-' }}
            </td>
          </el-tooltip>
          <el-tooltip  placement="top">
            <div slot="content">
              {{ item.zydhStr2?item.zydhStr2:'-' }}
            </div>
            <td width="112px" style="white-space:nowrap;
            text-overflow:ellipsis;overflow:hidden;max-width: 113px;">
              {{ item.zydhStr2?item.zydhStr2:'-' }}
            </td>
          </el-tooltip>
          <el-tooltip  placement="top">
            <div slot="content">
              {{ item.zydhStr3?item.zydhStr3:'-' }}
            </div>
            <td width="112px" style="white-space:nowrap;
            text-overflow:ellipsis;overflow:hidden;max-width: 113px;">  
              {{ item.zydhStr3?item.zydhStr3:'-' }}
            </td>
          </el-tooltip>
          <el-tooltip  placement="top">
            <div slot="content">
              {{ item.zydhStr4?item.zydhStr4:'-' }}
            </div>
            <td width="112px" style="white-space:nowrap;
            text-overflow:ellipsis;overflow:hidden;max-width: 113px;">
              {{ item.zydhStr4?item.zydhStr4:'-' }}
            </td>
          </el-tooltip>
          <el-tooltip  placement="top">
            <div slot="content">
              {{ item.zydhStr5?item.zydhStr5:'-' }}
            </div>
            <td width="112px" style="white-space:nowrap;
            text-overflow:ellipsis;overflow:hidden;max-width: 113px;">
              {{ item.zydhStr5?item.zydhStr5:'-' }}
            </td>
          </el-tooltip>
          <el-tooltip  placement="top">
            <div slot="content">
              {{ item.zydhStr6?item.zydhStr6:'-' }}
            </div>
            <td width="112px" style="white-space:nowrap;
            text-overflow:ellipsis;overflow:hidden;max-width: 113px;">
              {{ item.zydhStr6?item.zydhStr6:'-' }}
            </td>
          </el-tooltip>
          <td width="50px"
          style="max-width: 50px;">服从</td>
        </tr>
      </table>
    </div>
    
        <div>
          <el-table border size="small" :data="colleges"
          :span-method="objectSpanMethod" max-height="300"
          :cell-style="objectCellMethod"
          :header-cell-style="objHeaderCellMethod">
            <el-table-column label="序号" prop="xh" width="60"
             show-overflow-tooltip :resizable="false"></el-table-column>
            <el-table-column label="院校代号" prop="sb" width="60"
             show-overflow-tooltip :resizable="false"></el-table-column>
            <el-table-column label="院校名称" prop="yxmc" width="170"
             show-overflow-tooltip :resizable="false"></el-table-column>
            <el-table-column label="专业组" prop="zyz" width="80"
             show-overflow-tooltip :resizable="false"></el-table-column>
            <el-table-column label="年度" prop="nd" width="70"
             show-overflow-tooltip :resizable="false"></el-table-column>
            <el-table-column label="投档线" prop="lowestScore" width="80"
             show-overflow-tooltip :resizable="false"></el-table-column>
            <el-table-column label="专业一" prop="zydhStr1" width="110"
             show-overflow-tooltip :resizable="false"></el-table-column>
            <el-table-column label="专业二" prop="zydhStr2" width="110"
             show-overflow-tooltip :resizable="false"></el-table-column>
            <el-table-column label="专业三" prop="zydhStr3" width="110"
             show-overflow-tooltip :resizable="false"></el-table-column>
            <el-table-column label="专业四" prop="zydhStr4" width="110"
             show-overflow-tooltip :resizable="false"></el-table-column>
            <el-table-column label="专业五" prop="zydhStr5" width="110"
             show-overflow-tooltip :resizable="false"></el-table-column>
            <el-table-column label="专业六" prop="zydhStr6" width="110"
             show-overflow-tooltip :resizable="false"></el-table-column>
            <el-table-column label="是否服从" prop="sffc" width="60"
             show-overflow-tooltip :resizable="false">
              <template slot-scope="scope">
                <span v-if="scope.row.sffc>0">服从</span>
              </template>
            </el-table-column>
          </el-table>
          
        </div>
    </div>
        <!-- <textarea disabled class="specialInput" style="width: 790px;min-height: 100px;resize: none;"
        v-model="userInfo.bz" ></textarea> 
        margin-left: 60px; justify-content:space-between;margin-right: 20px;-->
    <div style="display: flex;align-items: flex-end;justify-content:space-between;">
      <div style="display: flex;align-items: center;">
        <span>备注：</span>
        <input disabled class="specialInput" style="width: 810px;min-height: 100px;"
        v-model="userInfo.bz"/>
      </div>
      <div style="margin-bottom: 0;margin-right: 30px;">
        <div>
          咨询师签名：

        </div>
        <div style="display: flex;">
          <div style="display: flex;">日<div style="width: 40px;"></div>期：</div>
          <div style="display: flex;">
            <div style="display: flex;">
              <div style="width: 60px;"></div>年
            </div>
            <div style="display: flex;">
              <div style="width: 60px;"></div>月
            </div>
            <div style="display: flex;">
              <div style="width: 60px;"></div>日
            </div>
            </div>
        </div>
      </div>
    </div>
    
    <div class="downLoad">
      <el-button type="primary" size="small" @click="downLoadData">下载表格<i class="el-icon-download el-icon--right"></i></el-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: "CompareTable",
  props: {
    colleges: {
      type: Array,
      default: []
    }
  },
  methods: {
    downLoadData() {
      this.$emit("download");
    },
    // 排序
    sortData() {
      this.$emit("sortData");
    },
    // 排序
    sortData2() {
      this.$emit("sortData2");
    },
    // 排序
    sortData3() {
      this.$emit("sortData3");
    },
    objectSpanMethod({row, column, rowIndex, columnIndex }){     
        if(columnIndex===0||columnIndex===1||columnIndex===2||columnIndex===3
          ||columnIndex===6||columnIndex===7||columnIndex===8||columnIndex===9
          ||columnIndex===10||columnIndex===11||columnIndex===12
        ){
            if(rowIndex%3===0){
                return{
                    rowspan:3,
                    colspan:1
                };
            }else {
                return {
                    rowspan:0,
                    colspan:0
                };
            }
        }
    },
    objectCellMethod({row,column,rowIndex,columnIndex}){
      if(columnIndex>=0){
        return {
          'box-sizing':'border-box',
          'border':'0.5px solid #DCDFE6',
          'text-align':'left',
          'vertical-align':'middle',
          'font-size':'14px'
        };
      }
    },
    objHeaderCellMethod({row,column,rowIndex,columnIndex}){
      if(columnIndex>=0){
        return {
            'box-sizing':'border-box',
            'background-color':'#f8f8f9',
            'border': '0.5px solid #DCDFE6',
            'color': '#666',
            'text-align':'center',
            'vertical-align':'middle',
            'font-size':'14px'
            }
        }
      }
  },
  computed:{
    ...mapState(["userInfo"])
  }
};
</script>

<style lang="stylus" scoped>
.compare-wrap
  .info-data-wrap
    max-height 500px
    overflow-y auto
    .sort-wrap
      text-align right
      padding-bottom 5px
  .info-data
    table-layout fixed
    width 100%
    color #666
    font-size 14px
    th
        box-sizing border-box
        border 1px solid #DCDFE6
        padding 5px
        text-align center
        vertical-align middle
        background-color #f8f8f9
    td
        box-sizing border-box
        padding 5px
        border 1px solid #DCDFE6
        text-align left
        vertical-align middle
  .info-data
    tr:not(tr:last-child) td
      border-top none   
  .downLoad 
    margin-top 20px
    text-align center       

</style>

        <!-- text-align center     -->
<style lang="less" scoped>

.specialInput{
                box-sizing: border-box;
              height: 30px;
              border-radius: 5px;
              padding-left: 10px;
              outline: none;
              border: 1px solid #dcdfe6;
              transition: all 0.5s;
              color: #303133;box-sizing: border-box;
              height: 30px;
              border-radius: 5px;
              padding-left: 10px;
              outline: none;
              border: 1px solid #dcdfe6;
              transition: all 0.5s;
              color: #303133;
}
</style>
